var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowAni(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n@keyframes a0_t { 0% { transform: translate(-2px,0px); } 50% { transform: translate(21px,0px); } 100% { transform: translate(21px,0px); } }\n@keyframes a1_t { 0% { transform: translate(-21.1px,0px); } 50% { transform: translate(-21.1px,0px); } 100% { transform: translate(-1.7px,0px); } }\n@keyframes a1_v { 0% { visibility: hidden; animation-timing-function: steps(1); } 50% { visibility: visible; animation-timing-function: steps(1); } 60% { visibility: visible; animation-timing-function: steps(1); } 100% { visibility: visible; animation-timing-function: steps(1); } }\n    ")), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.5 3l9.5 9m0 0l-9.5 9m9.5-9h-16",
    transform: "translate(10,12) translate(-12,-12)",
    style: {
      animation: "1s linear infinite both a0_t"
    }
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.5 3l9.5 9m0 0l-9.5 9m9.5-9h-16",
    visibility: "hidden",
    transform: "translate(-9.1,12) translate(-12,-12)",
    style: {
      animation: "1s linear infinite both a1_t, 1s linear infinite forwards a1_v"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowAni);
export default __webpack_public_path__ + "static/media/right_arrow_ani.f4c6b5452be346be761ed30947d58cf0.svg";
export { ForwardRef as ReactComponent };